import type { RootState } from 'src/redux/store'

export const selectMenuProductList = (state: RootState) => state['@menu']
